import { StreamActions } from "@hotwired/turbo"
import { bootstrapToast } from "../utils/bs_toast"

StreamActions.notify = function() {
  const message = this.getAttribute("message")

  // Optionale Optionen
  const type = this.getAttribute("type")
  const duration = this.getAttribute("duration")
  const autohide = this.getAttribute("autohide")
  const animation = this.getAttribute("animation")

  // Nur Optionen setzen, wenn sie übergeben wurden
  const options = {}
  if (type) options.type = type
  if (duration) options.duration = duration
  if (autohide) options.autohide = autohide
  if (animation) options.animation = animation

  bootstrapToast(message, options)
}

StreamActions.dispatch_js_event = function () {
  const eventName = this.getAttribute("event_name");
  const selector = this.getAttribute("selector");
  const event = new Event(eventName);

  if (selector === "window") {
    window.dispatchEvent(event)
  } else if (selector === "document") {
    document.dispatchEvent(event)
  } else {
    document.querySelector(selector).dispatchEvent(event);
  }
};

StreamActions.close_bs_modal = function() {
  window.dispatchEvent(new CustomEvent("equis:hide-bs-modal"));
}

StreamActions.postfinance_light_box_oeffnen = function() {
  const postfinanceLightBoxUrl = this.getAttribute("lightbox_js_url");
  const script = document.createElement('script');
  script.src = postfinanceLightBoxUrl;
  script.onload = function () {
    if (window.LightboxCheckoutHandler == undefined) {
      alert("PostFinance ist momentan nicht erreichbar");
    } else {
      window.LightboxCheckoutHandler.startPayment(null, function(){
        alert("PostFinance ist momentan nicht erreichbar");
      });
    }
  }
  document.head.appendChild(script);
}

// In den meisten Fällen kann man die `add_css_class` von TurboPower verwenden.
// Wenn eine Klasse wie z.B. `highlight` aber immer auf das Element angewendet werden soll,
// auch wenn es schon vorhanden ist, nutzen wir unsere eigene Implementierung
// welche die Klasse zuerst entfernt und dann wieder hinzufügt.
StreamActions.reapply_css_class = function() {
  const cssClass = this.getAttribute("css_class");

  // Zuerst die CSS Klasse entfernen
  this.targetElements.forEach((element) => element.classList.remove(cssClass))

  // Und nach 100ms wieder hinzufügen
  setTimeout(() => {
    this.targetElements.forEach((element) => element.classList.add(cssClass))
  }, 200);
}

StreamActions.reset_async_turbo_frames = function () {
  document.querySelectorAll('turbo-frame[src]').forEach(frame => {
    frame.removeAttribute("complete")
    frame.setAttribute("loading", frame.getAttribute("loading"))
  });
}
